import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

// import logo from "../../assets/images/Favicon.png"
// import logoLightPng from "../../assets/images/logo-light.png"
// import logoLightSvg from "../../assets/images/TruGrip Swift Launch Logo.png"
// import logoDark from "../../assets/images/logo-dark.png"

// import logo from "../../assets/images/companylogo1.png"

function tAdd() {
  var body = document.body
  body.classList.add("vertical-collpsed")
  // body.classList.add("sidebar-enable")
}

let logo = "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Asian%20Paints%20Swift%20Launch%2FLoader%20Logo.png?alt=media&token=74d18dcb-b0bc-449b-ba5d-d6d3e80163fbhttps://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Asian%20Paints%20Swift%20Launch%2FTrue%20Grip%20Favicon.png?alt=media&token=2536aef2-a86f-40ed-bc72-2d391da25724"

const Sidebar = props => {
    useEffect(()=>{
      tAdd() 
    },[])
  return (
    <React.Fragment>
      <div
        className="vertical-menu newnav" style={{position:"fixed", zIndex:101}}>
        <div className="navbar-brand-box">
          <Link to="#" className="logo logo-dark">
            <span className="logo-sm">
              <img loading="lazy"  src={logo} alt="" height="16" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logo} alt="" height="40" />
            </span>
          </Link>

          <Link to="#" className="logo logo-light">
            <span className="logo-sm">
              <img loading="lazy" src={logo} alt="" height="16" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logo} alt="" height="40" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
